import bindControlToForm from '../../utils/hoc/formHelpers/bindControlToForm';
import autoSaved from '../../utils/hoc/formHelpers/autoSaved';
import Switcher from './Switcher';

export default Switcher;
export const SwitcherControl = bindControlToForm()(Switcher);
export const AutoSavedSwitcherControl = autoSaved({ saveOnChange: true, saveOnBlur: true })(SwitcherControl);
